import { createFileRoute } from "@tanstack/react-router";
import { env } from "@/env";
import { FilSpesifikasjon } from "@/features/dokumentasjon/FilSpesifikasjon";

export const Route = createFileRoute("/_public/dokumentasjon/eksporter")({
  component: Index,
  head: () => ({
    meta: [
      {
        title: "Dokumentasjon Eksporter | Norgespris for fjernvarme",
      },
    ],
  }),
});

function Index() {
  // env.appBasePath can be "/" or "/selskapsportal"
  // prefix file paths with "" or "/selskapsportal"
  const appBasePathPrefix =
    env.appBasePath === "/"
      ? ""
      : env.appBasePath.endsWith("/")
        ? env.appBasePath.slice(0, -1)
        : env.appBasePath;

  const markdownFilePublicPath = `${appBasePathPrefix}/dokumentasjon/csv_eksport_leverandoer_avtaler_1.0.md`;
  const exampleFileMacPublicPath = `${appBasePathPrefix}/dokumentasjon/eksport-eksempel-utf8.csv`;
  const exampleFileWindowsPublicPath = `${appBasePathPrefix}/dokumentasjon/eksport-eksempel-windows.csv`;
  const helpLink = `/veiledning`;

  const markdownFileDownloadName = "filspesifikasjon-norgespris-avtaler.md";
  const exampleFileDownloadName = "norgespris-avtaler-123456789-2025-09-01.csv";

  return (
    <FilSpesifikasjon
      markdownFilePublicPath={markdownFilePublicPath}
      markdownFileDownloadName={markdownFileDownloadName}
      exampleFileWindowsPublicPath={exampleFileWindowsPublicPath}
      exampleFileMacPublicPath={exampleFileMacPublicPath}
      exampleFileDownloadName={exampleFileDownloadName}
      helpLink={helpLink}
    />
  );
}
